import StickerColor from "@/domains/Stickers/StickerColor";
import StickerColorsDAO from "@/domains/Stickers/StickerColorsDAO";
import Core from "@/core/Core";
import Dictionary from "@/core/types/Dictionary";

class StickerColorsService {

	/**
	 * Кеш цветов стикеров. Наполняется из Dictionaries общим эндпоинтом.
	 * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
	 */
	static stickerColors = reactive(new Dictionary<number, StickerColor>());

	static async getList(): Promise<StickerColor[]> {
		const response = await StickerColorsDAO.getList();

		if (!response.ok) {
			Core.showNotification.error('При получении цветов произошла ошибка');
			return [];
		}

		const result = Core.utils.hydrateArray(response.data, StickerColor.fromServer);

		this.stickerColors.reset(result);

		return result;
	}
}

export default StickerColorsService;
